import { Container, IInit } from 'common/container/Container'
import { IStatusService } from 'common/status/StatusService'
import { Observable } from 'rxjs'
import { Query } from 'common/api/Query'
import { ItemList } from 'common/models/ItemList'
import { STATUS_SERVICE_KEY } from 'container/app'
import {
  ExternAppointment,
  ExternAppointmentQuery,
} from 'modules/calendar/models/ExternAppointment'
import { ExternAppointmentDTO } from 'modules/calendar/models/ExternAppointmentDTO'
import { IExternAppointmentApi } from 'modules/calendar/api/ExternAppointmentApi'
import { ExternAppointmentAction } from '../enums/ExternAppointmentAction'

type Props = {
  apiKey: symbol
}

export interface IExternAppointmentService extends IInit {
  getByID(id: string): Observable<ExternAppointment | undefined>

  getFilteredList(q: Query<ExternAppointmentQuery>): Observable<ItemList<ExternAppointment>>

  add(e: ExternAppointment): Observable<ExternAppointment | undefined>

  update(e: ExternAppointmentDTO): Observable<ExternAppointment | undefined>

  delete(id: string): Observable<boolean>

  modifyAppointmentStatus(
    id: string,
    action: ExternAppointmentAction,
    cancelMessage?: string,
    cancelUserId?: string
  ): Observable<boolean>
}

export class ExternAppointmentService implements IExternAppointmentService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IExternAppointmentApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IExternAppointmentApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: ExternAppointmentDTO): Observable<ExternAppointment | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  getByID(id: string): Observable<ExternAppointment | undefined> {
    return this._api.getByID(id)
  }

  getFilteredList(q: Query<ExternAppointmentQuery>): Observable<ItemList<ExternAppointment>> {
    return this._api.getFilteredList(q)
  }

  update(e: ExternAppointmentDTO): Observable<ExternAppointment | undefined> {
    return this._api.update(e)
  }

  modifyAppointmentStatus(
    id: string,
    action: ExternAppointmentAction,
    cancelMessage?: string,
    cancelUserId?: string
  ): Observable<boolean> {
    return this._api.modifyAppointmentStatus(id, action, cancelMessage, cancelUserId)
  }
}
